import { Alert, Button } from "@blueprintjs/core";
import React, { useContext, useEffect, useState } from "react";
import LoadingElement from "../../components/elements/Loading.Element";
import { DB_REF } from "../../constants/DB";
import { firebaseContext } from "../../contexts/FirebaseContext";
import { PlayerRequest } from "../../interfaces/PlayerRequest.interface";
import "./NewPlayerRequests.Styles.scss";

export default function NewPlayerRequestsComponent() {
  const firebase = useContext(firebaseContext);
  const [requests, setRequests] = useState<PlayerRequest[]>([]);
  const [loading, setLoading] = useState(true);
  const [uid, setUid] = useState("");

  useEffect(() => {
    const getAllRequests = async () => {
      const db = firebase.firestore();

      db.collection(DB_REF.playerRequests)
        .where("accepted", "==", "waiting")
        .onSnapshot((query) => {
          const q: PlayerRequest[] = [];
          query.forEach((e) => {
            q.push(e.data() as any);
          });
          setRequests(q);
          setLoading(false);
        });
    };

    getAllRequests();
  }, [firebase]);

  const onClickRemove = (uid: string) => {
    setUid(uid);
  };

  const onClickAccept = async (uid: string) => {
    try {
      const confirmPlayerRequest = firebase
        .functions()
        .httpsCallable("confirmPlayerRequest");
      const res = await confirmPlayerRequest({ userId: uid });
      console.log(res);
    } catch (err) {
      console.log(err);
    }
  };

  const renderRequests = () => {
    if (requests.length === 0) {
      return (
        <div style={{ textAlign: "center", paddingTop: 100 }}>
          No pending requests
        </div>
      );
    }
    return requests.map((ele, index) => {
      return (
        <div key={index} className="req-element">
          <div>
            <img height={"50px"} src={ele.user.photoURL} alt="" />
          </div>
          <div className="req-name">{ele.user.displayName}</div>
          <div className="button-container">
            <Button
              intent="success"
              text="Accept"
              onClick={() => onClickAccept(ele.user.uid)}
            />
            <Button
              intent="danger"
              onClick={() => onClickRemove(ele.user.uid)}
              text="Remove"
            />
          </div>
        </div>
      );
    });
  };

  const onCancel = () => {
    setUid("");
  };

  const onConfirm = () => {
    const removeUserCall = firebase
      .functions()
      .httpsCallable("deletePlayerRequest", {});
    removeUserCall({ userId: uid, uid: "" })
      .then((res) => {
        console.log(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    setUid("");
  };

  if (loading) {
    return <LoadingElement />;
  }

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
          padding: 25,
        }}
      >
        New Player Requests
      </div>
      <div>{renderRequests()}</div>
      <Alert
        className="bp3-dark"
        cancelButtonText="Cancel"
        intent="danger"
        isOpen={uid !== ""}
        confirmButtonText="Delete"
        onCancel={onCancel}
        onConfirm={onConfirm}
      >
        <p>Do you really want to delete the player request?</p>
      </Alert>
    </div>
  );
}
